var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.8399 14.9895C17.8399 15.9657 17.0261 16.7603 16.0262 16.7603H12.7941V10.2147H15.0883L15.4139 7.71753H12.7941V6.12087C12.7941 5.39442 12.9956 4.90256 14.0652 4.90256H15.4216V2.67782C15.1891 2.64755 14.383 2.57945 13.4451 2.57945C11.4919 2.57945 10.151 3.74479 10.151 5.88629V7.73267H7.84899V10.2298H10.151V16.7754H2.70238C1.70252 16.7754 0.888672 15.9808 0.888672 15.0047V1.98165C0.888672 1.00549 1.70252 0.210938 2.70238 0.210938H16.0262C17.0261 0.210938 17.8399 1.00549 17.8399 1.98165V14.9895Z","fill":"currentColor"}));
}

Facebook.defaultProps = {"aria-hidden":"true","width":"18","height":"17","viewBox":"0 0 18 17","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
